export default {"src":"/_next/static/media/caret-right.cb17fc8e.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};